import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, TablePagination, Typography } from '@mui/material';
import { AdminTable, ColumnSort, TableProps, TableAction } from '../components';
import useAPI from '../../utils/useApi';
import { APIRequests } from '../../config/api';
import { ListResource, RequestInput } from '../../types';
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from 'react-router-dom';

export interface ListViewProps {
  title: string;
  tableProps: Partial<TableProps>;
  apiRequest: APIRequests;
  actions?: JSX.Element[];
  recordid?: string;
  relatedFilter?: string;
}

export const ListView = (props: ListViewProps) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<{ [name: string]: string }[]>();
  const [totalRows, setTotalRows] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [filter, setFilter] = useState<string>();
  const [sortValue, setSortValue] = useState<ColumnSort>();

  let dataList = useAPI<ListResource>(props.apiRequest);
  useEffect(() => {
    const cp = searchParams.get('p');
    const fil = searchParams.get('q');
    const s = searchParams.get('sort');
    const sd = searchParams.get('sortDir');
    if (cp) {
      setCurrentPage(parseInt(cp));
    }
    if (fil) {
      setFilter(fil);
    }
    if (s && sd) {
      setSortValue({ direction: sd, field: s });
    }
  }, []);
  useEffect(() => {
    const params: Record<string, string> = {};
    if (filter) {
      params['q'] = filter;
    }
    if (sortValue) {
      (params['sortDir'] = sortValue.direction),
        (params['sort'] = sortValue.field);
    }
    params['p'] = `${currentPage}`;
    const options = createSearchParams(params);
    setSearchParams(options);
  }, [filter, sortValue, currentPage]);

  useEffect(() => {
    let queryParams: { [name: string]: string } = {};
    queryParams['page'] = `${currentPage}`;
    if (sortValue) {
      queryParams['sort'] = sortValue.field;
      queryParams['sortDir'] = sortValue.direction;
    }
    if (filter) {
      queryParams['q'] = filter;
    }
    const req: RequestInput = { queryParams: queryParams };

    dataList.execute(req);
  }, [filter, sortValue, currentPage]);

  useEffect(() => {
    if (dataList.data) {
      console.log(dataList.data);
      setRows(dataList.data.records);
      setTotalRows(dataList.data.total);
    }
  }, [dataList.data]);

  const onFilter = (field: string, value: string) => {
    setRows([]);
    setFilter(`${field}='${value}'`);
  };

  const onSort = (data: ColumnSort) => {
    setSortValue(data);
  };

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };

  let actions: TableAction[] = [
    {
      header: 'View',
      onClick: (i: number, _: any | undefined) => {
        if (rows) {
          navigate(`${rows[i].id}`);
        }
      },
      icon: 'view',
      order: -1,
    },
  ];
  if (props.tableProps.actions) {
    actions.push(...props.tableProps.actions);
  }
  const tableProps = {
    ...props.tableProps,
    columns: props.tableProps.columns || [],
    rows: rows,
    actions: actions,
    onFilter: onFilter,
    sortData: onSort,
    emptyMessage: <Typography>No {props.title} found </Typography>,
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <Typography variant="h5" sx={{ px: 2, pb: 5 }}>
          {props.title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box display="flex" justifyContent="flex-end">
          {props.actions?.map((action: JSX.Element) => {
            return action;
          })}
        </Box>
      </Grid>
      <Grid container xs={12} justifyContent="right" pb={4}>
        {filter && (
          <Button onClick={() => setFilter(undefined)}> Clear Filter</Button>
        )}
        <TablePagination
          count={totalRows}
          onPageChange={handlePageChange}
          page={currentPage}
          rowsPerPage={100}
          rowsPerPageOptions={[100]}
        />
      </Grid>
      <Grid item xs={12}>
        <AdminTable {...tableProps} />
      </Grid>
    </Grid>
  );
};
